import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HubMode, Learnspace } from '@shared/models';

export interface ProgramListItemActionButtonConfiguration {
  label: string;
  action: () => void;
}

@Component({
  selector: 'program-list-item',
  templateUrl: './program-list-item.component.html',
  styleUrls: ['./program-list-item.component.scss']
})
export class ProgramListItemComponent {
  @Input() learnspace?: Learnspace;
  @Input() title: string;
  @Input() description: string;
  @Input() tags?: string[];
  @Input() poster: string;
  @Input() showCollaborators = false;
  @Input() collaboratorsCount?: number;
  @Input() experienceCount?: number;
  @Input() clickDeactived = false;
  @Input() canDelete = false;
  @Input() accessProtected = false;
  @Input() canNotEnter = false;
  @Input() isArchived = false;
  @Input() showMenu = false;
  @Input() actionButtons?: ProgramListItemActionButtonConfiguration[];
  @Input() canCreateSpace?: boolean;
  
  @Output() enter = new EventEmitter<void>();
  @Output() showParticipants = new EventEmitter<void>();
  @Output() update = new EventEmitter<void>();
  @Output() delete = new EventEmitter<void>();
  @Output() unsubscribe = new EventEmitter<void>();
  @Output() contactSales = new EventEmitter<void>();
  @Output() duplicate = new EventEmitter<void>();

  mode = HubMode.program;
}
